<template>
  <div class="background-bg" onpaste="return false" id="register-container">
    
    <!-- <div class="back-div py-3">
      <div class="back-div-text">
        <p class="m-0 p-0 back-div-text-style" @click="goToHomePage()">
          <img class="right-arrow left-arrow" src="@/assets/images/right-arrow.svg" />&nbsp;&nbsp;Back
        </p>
      </div>
    </div>-->
    <div v-if="!regComplete">
      <div>
        <div
          class="partner-registration-heading py-3"
        ><span>{{ $t("REGISTRATION_PAGE.PARTNER_REGISTRATION") }}</span>
    
        <span class="m-0 p-0 back-div-text-style" style="float:right;" @click="goToHomePage()"> 
          <img class="right-arrow left-arrow" src="@/assets/images/right-arrow.svg" />&nbsp;&nbsp;Back
        </span>
        
        <div style="    
        background-color: #ffe9a5;
    font-size: 15px;
    padding: 5px;
    text-align: center;
    color: rgb(169,0,0);margin-top: 5px;">
         Note: Registration is applicable only for the new Vendors. Existing vendors kindly contact L&T contact person.</div></div>
      </div>
      <v-expansion-panel v-model="panel">
        <v-expansion-panel-content expand-icon="mdi-menu-down">
          <template v-slot:header>
            <div v-if="panel == 0">
              <img class="mr-4" src="@/assets/images/downArrow.svg" />
              {{ $t("REGISTRATION_PAGE.KYC_DETAILS") }}
              <v-icon
                v-if="
                  form.country ||
                    form.nationalId ||
                    form.organizationName ||
                    form.identityNumber
                "
                :class="checkStatus('kyc')"
              >check</v-icon>
            </div>
            <div v-else>
              <img class="mr-4" src="@/assets/images/upArrow.svg" />
              {{ $t("REGISTRATION_PAGE.KYC_DETAILS") }}
              <v-icon
                v-if="
                  form.country ||
                    form.nationalId ||
                    form.organizationName ||
                    form.identityNumber
                "
                :class="checkStatus('kyc')"
              >check</v-icon>
            </div>
          </template>
          <v-card>
            <div>
              <div class="row m-0 px-5 ml-4 py-3">
                <div class="col-md-6 col-lg-3">
                  <b-form-group
                    class="exo-regular field-headings"
                    :label="
                      $t(
                        'REGISTRATION_PAGE.PARTNER_REGISTRATION_CONTENT.COUNTRY'
                      )
                    "
                  >
                    <w-dropdown
                      class="width-control-small"
                      :options="countries"
                      :disabled="
                        identityNumberValidation != null &&
                          identityNumberValidation !=
                            'Invalid ' + form.nationalId
                      "
                      @dropdownChange="getCountry($event)"
                      :selected="selectedCountry"
                      autocomplete="off"
                    />
                  </b-form-group>
                </div>
                <div class="col-md-6 col-lg-3">
                  <b-form-group class="exo-regular field-headings" label="National ID *">
                    <w-dropdown
                      class="width-control-small"
                      :options="nationalIds"
                      :disabled="
                        identityNumberValidation != null &&
                          identityNumberValidation !=
                            'Invalid ' + form.nationalId
                      "
                      @dropdownChange="getNationalId($event)"
                      :selected="form.nationalId"
                      autocomplete="off"
                    />
                  </b-form-group>
                </div>
                <!--div class="col-md-6 col-lg-3" v-if="form.country.countryCode!='100'">
                  <b-form-group class="exo-regular field-headings" label="National ID Type*">
                    <input type="text" v-model="form.nationalId" class="form-control"/>
                  </b-form-group>
                </div-->
                <div class="col-md-6 col-lg-3">
                  <w-text-input
                    :labelName="
                      $t(
                        'REGISTRATION_PAGE.PARTNER_REGISTRATION_CONTENT.ORGANIZATION_NAME'
                      ) + '*'
                    "
                    @textInputChange="getOrganizationName($event)"
                    validation="required"
                    autocomplete="off"
                    :errorMessage="
                      $t(
                        'REGISTRATION_PAGE.PARTNER_REGISTRATION_CONTENT.ORGANIZATION_NAME'
                      )
                    "
                    :maxCharacter="'150'"
                  />
                </div>
                
                <div class="col-md-6 col-lg-3" v-if="form.country.countryCode!='100' && form.nationalId &&
                form.nationalId.trim().length>0">
                  <b-form-group class="exo-regular field-headings" :label="form.nationalId+'*'">
                    <input type="text" v-model="form.identityNumber" class="form-control" 
                    @input="foreignIdValidation()" @blur="verifyIdentityCard()" maxlength="30"/>
                  </b-form-group>
                </div>
                <div class="col-md-6 col-lg-3" v-if="form.country.countryCode == '100'">
                  <b-form-group
                    v-if="form.nationalId && form.country.countryCode == 100"
                    class="exo-regular field-headings"
                    :label="form.nationalId + '*'"
                  >
                    <div class="row identity-row">
                      <div class="col verify-input-col p-0">
                        <b-form-input
                          v-model="form.identityNumber"
                          name="Identity Number"
                          v-validate="'required'"
                          :state="errors.has('Identity Number') ? false : null"
                          class="width-control w-100 lato-regular-input"
                          :disabled="
                            identityNumberValidation != null &&
                              identityNumberValidation !=
                                'Invalid ' + form.nationalId
                          "
                          @keypress="defaultMsg($event)"
                          @keyup="defaultMsg($event)"
                        ></b-form-input>
                        <p
                          class="invalid-id"
                          v-if="
                            identityNumberValidation ==
                              'Invalid ' + form.nationalId &&
                              identityNumberValidation != null &&
                              !verifyLength() &&
                              !showInvalidError
                          "
                        >{{ identityNumberValidation }}</p>
                        <p
                          class="verified-already-exists-id"
                          v-if="
                            identityNumberValidation ==
                              'Verified but Already exists' &&
                              identityNumberValidation != null &&
                              !verifyLength()
                          "
                        >{{ identityNumberValidation }}</p>
                      </div>
                      <div class="col verify-col pl-3">
                        <b-button
                          v-if="
                            !verifiedAll() &&
                              identityNumberValidation !=
                                'Verified Successfully'
                          "
                          class="float-left verify-btn"
                          :disabled="
                            verifyLength() ||
                              (identityNumberValidation != null &&
                                identityNumberValidation !=
                                  'Invalid ' + form.nationalId)
                          "
                          @click="verifyIdentityCard($event)"
                        >
                          {{ $t("REGISTRATION_PAGE.VERIFY") }}
                          {{ form.nationalId }}
                        </b-button>
                        <p
                          v-if="
                            !verifiedAll() &&
                              identityNumberValidation ==
                                'Verified Successfully'
                          "
                          class="float-left m-0 verify-btn-success"
                        >
                          {{ $t("REGISTRATION_PAGE.VERIFIED") }}
                          {{ form.nationalId }}
                        </p>
                      </div>
                      
                        <p v-if="verifyLength()">*The {{form.nationalId}} number will be validated. Kindly provide correct PAN.
                        </p>
                    </div>
                  </b-form-group>
                </div>
              </div>
              <div class="row m-0 px-5 ml-4 pb-3">
                <div class="col-md-6 col-lg-3">
                  <w-text-input
                    :labelName="
                      $t(
                        'REGISTRATION_PAGE.PARTNER_REGISTRATION_CONTENT.DUNS_NUMBER'
                      )
                    "
                    @textInputChange="getDunsNumber($event)"
                    :validation="{ regex_duns: true, length: 9 }"
                    :type="'number'"
                    :inputAdditions="'mobile'"
                    :maxDigits="'9'"
                    :errorMessage="
                      $t(
                        'REGISTRATION_PAGE.PARTNER_REGISTRATION_CONTENT.DUNS_NUMBER'
                      )
                    "
                  />
                  <div
                    :class="'helo-block alert alert-danger errorWidth mt-1'"
                    v-if="dunsNumberExist && form.duns"
                  >{{ $t("DunsNumber is Invalid or it already exists!") }}</div>
                </div>
              </div>
            </div>
          </v-card>
        </v-expansion-panel-content>
        <v-expansion-panel-content expand-icon="mdi-menu-down">
          <template v-slot:header>
            <div v-if="panel == 1">
              <img class="mr-4" src="@/assets/images/downArrow.svg" />
              {{ $t("REGISTRATION_PAGE.CONTACT_DETAILS") }}
              <v-icon :class="checkStatus('contact_details')">check</v-icon>
            </div>
            <div v-else>
              <img class="mr-4" src="@/assets/images/upArrow.svg" />
              {{ $t("REGISTRATION_PAGE.CONTACT_DETAILS") }}
              <!-- v-if="form.coordinationPersonName || form.designation || form.mobileNumber || form.email" -->
              <v-icon :class="checkStatus('contact_details')">check</v-icon>
            </div>
          </template>
          <v-card>
            <div>
              
            <div style="text-decoration: underline;font-size: 13px;padding: 1px;
            text-align: left;color: #444444;margin: 0px 85px;border-radius:20px;
            ">
         <span style="font-size:18px;color:#ff4500;"> &#9888; </span>
         Kindly provide valid Mobile and Email Id. 
         OTP will be sent to the contacts should be verified for the registration to complete.
      </div>
              <div class="row m-0 px-5 ml-4 pt-3">
                <div class="col-md-6 col-lg-3">
                  <w-text-input
                    :labelName="
                      $t(
                        'REGISTRATION_PAGE.PARTNER_REGISTRATION_CONTENT.COORDINATION_PERSON_NAME'
                      ) + '*'
                    "
                    @textInputChange="getCoordinationPersonName($event)"
                    validation="required"
                    :allowOnlyCharacters="true"
                    :errorMessage="
                      $t(
                        'REGISTRATION_PAGE.PARTNER_REGISTRATION_CONTENT.COORDINATION_PERSON_NAME'
                      )
                    "
                    :maxCharacter="'150'"
                  />
                </div>
                <div class="col-md-6 col-lg-3">
                  <w-text-input
                    :labelName="
                      $t(
                        'REGISTRATION_PAGE.PARTNER_REGISTRATION_CONTENT.DESIGNATION'
                      ) + '*'
                    "
                    @textInputChange="getDesignation($event)"
                    validation="required"
                    :allowOnlyCharacters="true"
                    :errorMessage="
                      $t(
                        'REGISTRATION_PAGE.PARTNER_REGISTRATION_CONTENT.DESIGNATION'
                      )
                    "
                    :maxCharacter="'150'"
                  />
                </div>
                <div class="col-md-6 col-lg-3">
                  <w-text-input
                    :labelName="
                      $t('REGISTRATION_PAGE.PARTNER_REGISTRATION_CONTENT.URL') + (' (optional)')
                    "
                    @textInputChange="getURL($event)"
                    :defaultValue="form.url"
                    :validation="{
                      regex: /^((ftp|http|https):\/\/)?(www.)?(?!.*(ftp|http|https|www.))[a-zA-Z0-9_-]+(\.[a-zA-Z]+)+((\/)[\w#]+)*(\/\w+\?[a-zA-Z0-9_]+=\w+(&[a-zA-Z0-9_]+=\w+)*)?$/
                    }"
                    :errorMessage="
                      $t('REGISTRATION_PAGE.PARTNER_REGISTRATION_CONTENT.URL')
                    "
                    :maxCharacter="'150'"
                  />
                </div>

                 <div class="col-md-6 col-lg-3">
                  <w-text-input
                    :inputAdditions="'mobile'"
                    :disabled="!form.country"
                    :labelName="
                      $t(
                        'REGISTRATION_PAGE.PARTNER_REGISTRATION_CONTENT.MOBILE_NUMBER'
                      ) + '*'
                    "
                    :validation="mobileValidationObj()"
                    @textInputChange="getPhoneNumber($event)"
                    :isdCode="isdCode"
                    :state="mobileNumberExists ? true : false"
                    :type="'number'"
                    autocomplete="off"
                    :maxDigits="mobileNumberSize"
                    :errorMessage="
                      $t(
                        'REGISTRATION_PAGE.PARTNER_REGISTRATION_CONTENT.MOBILE_NUMBER'
                      )
                    "
                  />
                  <div
                    :class="'helo-block alert alert-danger errorWidth mt-1'"
                    v-if="mobileNumberExists && form.mobileNumber"
                  >{{ $t("Mobile Number Invalid or it already exists!") }}</div>
                </div>
              </div>
              
                
                <div class="row m-0 px-5 ml-4 pt-3">
                <div class="col-md-6 col-lg-3" :class="emailOTPVerified ? 'disabled': ''">
                  <w-text-input
                    :labelName="
                      $t(
                        'REGISTRATION_PAGE.PARTNER_REGISTRATION_CONTENT.EMAIL'
                      ) + '*'
                    "
                    @textInputChange="getEmail($event)"
                    :defaultValue="form.email"
                    validation="required|email"
                    :errorMessage="
                      $t('REGISTRATION_PAGE.PARTNER_REGISTRATION_CONTENT.EMAIL')
                    "
                    :maxCharacter="'150'"
                  />
                  <div
                    :class="
                      'helo-block alert alert-danger errorWidth m-0 p-3 ml-1 mt-1'
                    "
                    v-if="emailExists && form.email"
                  >{{ $t("Email ID Invalid or it already exists!") }}</div>
                  <div
                    :class="
                      'helo-block alert alert-danger errorWidth m-0 p-3 ml-1 mt-1'
                    "
                    v-if="restrictEmail && form.email"
                  >{{ $t("Email ID of this domain is Restricted!") }}</div>
                </div>
                
                 <div class="col">
                <div style="top: 28px;position: absolute;">
                    <input type="number" class="form-control" style="
                      display: inline-block;margin-right:15px;
                      width: 110px;" v-if="otpSentToEmail && !emailOTPVerified"
                      v-model="emailOTP" @keypress="emailOTP = emailOTP.substring(0, 5)"
                      :placeholder="'Enter OTP'"/>
                    <button class="btn btn-primary" style="
                      display: inline-block; margin-right:15px;"
                      @click="sendOTPtoEmail()"
                      :class="!form.email || (emailExists || restrictEmail) || invalidEmailPattern ? 'disabled' : ''"
                      v-if="!otpSentToEmail && !emailOTPVerified">Send OTP to Email</button>
                      
                    <button class="btn btn-success"  style="
                      display: inline-block; margin-right:15px;"
                      v-if="otpSentToEmail && !emailOTPVerified"
                      @click="verifyEmailOTP()">Verify</button>
                      
                    <button class="btn btn-primary" style="
                      display: inline-block; margin-right:15px;"
                      v-if="otpSentToEmail && !emailOTPVerified && false">Re-Send OTP to Email</button>
                      <span style="color:#228b22 !important;font-weight:bold;"
                      v-if="emailOTPVerified"> &#10003; Email Verifed</span>
                </div>
              </div> 
                </div>
            </div>
          </v-card>
        </v-expansion-panel-content>
        <v-expansion-panel-content expand-icon="mdi-menu-down">
          <template v-slot:header>
            <div v-if="panel == 2">
              <!-- v-if="form.partner!=null || form.primaryBusiness != null || form.primaryCategory.length>0 || form.primarySubCategory.length>0" -->
              <img class="mr-4" src="@/assets/images/downArrow.svg" />
              {{ $t("REGISTRATION_PAGE.BUSINESS_PROFILE") }}
              <span class="inf" :title="biz">i</span>
              <v-icon :class="checkStatus('business_profile')">check</v-icon>
            </div>
            <div v-else>
              <img class="mr-4" src="@/assets/images/upArrow.svg" />
              {{ $t("REGISTRATION_PAGE.BUSINESS_PROFILE") }}
              <span class="inf" :title="biz">i</span>
              <v-icon :class="checkStatus('business_profile')">check</v-icon>
            </div>
          </template>
          <v-card>
            <div>
              <div class="row m-0 px-5 ml-4">
                <div class="col-md-6 col-lg-3">
                  <b-form-group
                    class="exo-regular field-headings"
                    :label="
                      $t(
                        'REGISTRATION_PAGE.PARTNER_REGISTRATION_CONTENT.PARTNER_FOR'
                      )
                    "
                  >
                    <w-dropdown
                      class="width-control"
                      :options="partnerList"
                      @dropdownChange="getPartner($event)"
                      :selected="form.partner"
                    />
                  </b-form-group>
                </div>
              </div>
              <div class="row m-0 px-5 ml-4">
                <div class="col-md-6 col-lg-2">
                  <b-form-group
                    class="exo-regular field-headings"
                    :label="
                      $t(
                        'REGISTRATION_PAGE.PARTNER_REGISTRATION_CONTENT.PRIMARY_BUSINESS'
                      )
                    "
                  >
                    <w-dropdown
                      class="width-control"
                      :disabled="!form.partner"
                      :options="primaryBusiness"
                      @dropdownChange="getPrimaryBusiness($event)"
                      :selected="form.primaryBusiness"
                    />
                  </b-form-group>
                </div>
                
                <div class="col-md-6 col-lg-2"> 
                  <b-form-group v-if="form.primaryBusiness==2 || !form.primaryBusiness || !form.partner"
                    class="exo-regular field-headings"
                    :label="'Business Type*'"
                  >
                    <w-dropdown
                      class="width-control"
                      :disabled="!form.partner || !form.primaryBusiness"
                      :options="primaryBusinessTypes"
                      @dropdownChange="getprimaryBusinessTypes($event)"
                      :selected="form.primaryBusinessTypesSelected"
                    />
                  </b-form-group>

                  <p class="exo-regular field-p-primary-category m-0 no-weight pb-1"
                  v-if="form.primaryBusiness==3">
                    Business Type*
                  </p>
                 
                  <multiSelect v-if="form.primaryBusiness==3"
                    id="multiSelectPrimarySubCategory"
                    :disabled="!primaryBusinessTypes.length"
                    class="field-headings pt-1"
                    v-model="form.primaryBusinessTypesSelected"
                    :position="position"
                    :options="optionsForSubCategory"
                    :selectOptions="primaryBusinessTypes"
                    :btnLabel="btnLabelBusinessTypesPrimary"
                    :search="true"
                  />
                </div>

                <div class="col-md-6 col-lg-3">
                  <p class="exo-regular field-p-primary-category m-0 no-weight pb-1">
                    {{
                    $t(
                    "REGISTRATION_PAGE.PARTNER_REGISTRATION_CONTENT.PRIMARY_CATEGORY"
                    )
                    }}
                  </p>
                  <multiSelect
                    id="multiSelectPrimaryCategory"
                    :disabled="!form.primaryBusiness"
                    class="field-headings pt-1"
                    v-model="form.primaryCategory"
                    :position="position"
                    :options="options"
                    @close="getPrimaryCategory()"
                    :selectOptions="primaryCategory"
                    :btnLabel="btnLabelPrimaryCategory"
                    :search="true"
                  />
                </div>
                <div class="col-md-6 col-lg-3">
                  <p class="exo-regular field-p-primary-category m-0 no-weight pb-1">
                    {{
                    $t(
                    "REGISTRATION_PAGE.PARTNER_REGISTRATION_CONTENT.PRIMARY_SUBCATEGORY"
                    )
                    }}
                  </p>
                 
                  <multiSelect
                    id="multiSelectPrimarySubCategory"
                    :disabled="!form.primaryCategory.length"
                    class="field-headings pt-1"
                    v-model="form.primarySubCategory"
                    :position="position"
                    :options="optionsForSubCategory"
                    :selectOptions="primarySubCategory"
                    :btnLabel="btnLabelPrimarySubCategory"
                    :search="true"
                  />
                </div>
                <div class="col-md-6 col-lg-2">
                  <p
                    class="exo-regular field-p-primary-category m-0 no-weight pb-1"
                  > 
                  <span v-if="form.primaryBusiness == 2">Key Material*</span>
                  <span v-else-if="form.primaryBusiness == 3">Workgroup*</span>
                  <span v-else>Key Category*</span>
                  <sup><span title="Primary Category for Approval*" class="inf"
                  style="padding: 0px 5px !important;font-size: 12px !important;">i</span></sup> 


                  </p> 
                  <w-dropdown
                    class="width-control"
                    :disabled="!form.primaryCategory.length > 0"
                    :options="specializedPrimaryCategory(form.primaryCategory)"
                    @dropdownChange="getCategoryForApproval($event)"
                    :selected="form.specializedPrimaryCategory"
                  />
                </div>
              </div>
              <div class="row m-0 ml-4 px-5">
                <div class="col-md-6 col-lg-2">
                  <b-form-group
                    class="exo-regular field-headings"
                    :label="
                      $t(
                        'REGISTRATION_PAGE.PARTNER_REGISTRATION_CONTENT.SECONDARY_BUSINESS'
                      )
                    "
                  >
                    <w-dropdown
                      :disabled="form.primaryBusiness == null"
                      class="width-control"
                      :options="secondaryBusiness"
                      @dropdownChange="getSecondaryBussiness($event)"
                      :selected="form.secondaryBusiness"
                      :search="true"
                    />
                  </b-form-group>
                </div>
                
                <div class="col-md-6 col-lg-2">
                  <b-form-group v-if="form.secondaryBusiness==2 || !form.secondaryBusiness || !form.partner"
                    class="exo-regular field-headings"
                    :label="'Business Type*'"
                  >
                    <w-dropdown
                      class="width-control"
                      :disabled="!form.partner || !form.secondaryBusiness"
                      :options="secondaryBusinessTypes"
                      @dropdownChange="getSecondaryBusinessTypes($event)"
                      :selected="form.secondaryBusinessTypesSelected"
                    />
                  </b-form-group>

                  <p class="exo-regular field-p-primary-category m-0 no-weight pb-1"
                  v-if="form.secondaryBusiness==3">
                    Business Type*
                  </p>
                  <multiSelect v-if="form.secondaryBusiness==3"
                    id="multiSelectPrimarySubCategory"
                    :disabled="!secondaryBusinessTypes.length"
                    class="field-headings pt-1"
                    v-model="form.secondaryBusinessTypesSelected"
                    :position="position"
                    :options="optionsForSubCategory"
                    :selectOptions="secondaryBusinessTypes"
                    :btnLabel="btnLabelBusinessTypesPrimary"
                    :search="true"
                  />
                </div>
                <div class="col-md-6 col-lg-3">
                  <p class="exo-regular field-p-primary-category m-0 no-weight pb-1">
                    {{
                    $t(
                    "REGISTRATION_PAGE.PARTNER_REGISTRATION_CONTENT.SECONDARY_CATEGORY"
                    )
                    }}
                  </p>
                  <multiSelect
                    id="multiSelectSecondaryCategory"
                    :disabled="!form.secondaryBusiness"
                    class="field-headings pt-1"
                    v-model="form.secondaryCategory"
                    :position="position"
                    :options="options"
                    @close="getSecondaryCategory()"
                    :selectOptions="secondaryCategory"
                    :btnLabel="btnLabelSecondaryCategory"
                    :search="true"
                  />
                </div>
                <div class="col-md-6 col-lg-3">
                  <p class="exo-regular field-p-primary-category m-0 no-weight pb-1">
                    {{
                    $t(
                    "REGISTRATION_PAGE.PARTNER_REGISTRATION_CONTENT.SECONDARY_SUBCATEGORY"
                    )
                    }}
                  </p>
                  <multiSelect
                    id="multiSelectSecondarySubCategory"
                    :disabled="!form.secondaryCategory.length"
                    class="field-headings pt-1"
                    v-model="form.secondarySubCategory"
                    :position="position"
                    :options="options"
                    :selectOptions="secondarySubCategory"
                    :btnLabel="btnLabelSecondarySubCategory"
                    :search="true"
                  />
                </div>
              </div>
            </div>
          </v-card>
        </v-expansion-panel-content>
        <v-expansion-panel-content expand-icon="mdi-menu-down">
          <template v-slot:header>
            <div v-if="panel == 3">
              <img class="mr-4" src="@/assets/images/downArrow.svg" />
              {{ $t("REGISTRATION_PAGE.CREDENTIALS") }}
              <!-- v-if="form.userName || form.password || form.reEnterPassword"/ -->
              <v-icon :class="checkStatus('credentials')">check</v-icon>
            </div>
            <div v-else>
              <img class="mr-4" src="@/assets/images/upArrow.svg" />
              {{ $t("REGISTRATION_PAGE.CREDENTIALS") }}
              <v-icon :class="checkStatus('credentials')">check</v-icon>
            </div>
          </template>
          <v-card>
            <div>
              <div class="row m-0 px-5 mb-5 ml-4 credentials">
                <div class="col-md-6 col-lg-3">
                  <b-form-group
                    class="lato-regular field-headings-userDetails mt-5 mb-5"
                    :label="
                      $t(
                        'REGISTRATION_PAGE.USER_CREDENTIALS_CONTENT.ENTER_USERNAME'
                      )
                    "
                  >
                    <b-form-input
                      v-model="form.userName"
                      name="UserName"
                      v-validate="'required|regex_userName|min:3'"
                      :state="errors.has('UserName') ? false : null"
                      class="width-control lato-regular-input"
                      @input="checkUserName()"
                      @keypress="validateInput($event)"
                      @keyup="validateInput($event)"
                    ></b-form-input>
                    <!-- <b-spinner
                      :variant="'warning'"
                      type="grow"
                    ></b-spinner>-->
                    <img
                      v-if="
                        userNameDuplicate &&
                          form.userName &&
                          form.userName.length > 2
                      "
                      class="checkUserSuccess"
                      src="@/assets/images/usernameCheck.svg"
                    />
                    <p
                      v-if="userNameDuplicate && form.userName"
                      class="username-available lato-regular mt-1"
                    >{{ $t("REGISTRATION_PAGE.USERNAME_AVAILABLE") }}</p>

                    <div
                      :class="
                        'helo-block alert alert-danger errorWidth errormsg-credential'
                      "
                      v-show="errors.has('UserName')"
                    >{{ errors.first("UserName") }}</div>
                    <div
                      :class="
                        'helo-block alert alert-danger errorWidth errormsg-credential'
                      "
                      v-if="!userNameDuplicate && form.userName"
                    >{{ $t("REGISTRATION_PAGE.USERNAME_ALREADY_REGISTERED") }}</div>
                  </b-form-group>
                </div>
                <div class="col-md-6 col-lg-3">
                  <b-form-group
                    class="lato-regular field-headings-userDetails mt-5 mb-5"
                    :label="
                      $t(
                        'REGISTRATION_PAGE.USER_CREDENTIALS_CONTENT.ENTER_PASSWORD'
                      )
                    "
                  >
                    <b-form-input
                      v-model="form.password"
                      :type="passwordType"
                      name="Password"
                      v-validate="'required|regex_password'"
                      :state="errors.has('Password') ? false : null"
                      ref="password"
                      autocomplete="off"
                      class="width-control-password lato-regular-input m-0 m-auto"
                      @keypress="validatePassword($event)"
                      @keyup="validatePassword($event)"
                    ></b-form-input>
                    <img :class="eyeStatus" @click="showPassword()" :src="imgSrc(eyeStatus)" />
                    <div
                      :class="
                        'helo-block alert alert-danger errorWidth errormsg-credential'
                      "
                      v-show="errors.has('Password')"
                    >{{ errors.first("Password") }}</div>
                  </b-form-group>
                </div>
                <div class="col-md-6 col-lg-3">
                  <b-form-group
                    class="lato-regular field-headings-userDetails mt-5 mb-5"
                    :label="
                      $t(
                        'REGISTRATION_PAGE.USER_CREDENTIALS_CONTENT.REENTER_PASSWORD'
                      )
                    "
                  >
                    <b-form-input
                      v-model="form.reEnterPassword"
                      :type="confirmPasswordType"
                      autocomplete="off"
                      name="Confirm Password"
                      :state="errors.has('Confirm Password') ? false : null"
                      v-validate="{ required: true, confirmed: form.password }"
                      class="width-control-password lato-regular-input m-0 m-auto"
                      @keypress="validatePassword($event)"
                      @keyup="validatePassword($event)"
                    ></b-form-input>
                    <img
                      :class="confirmEyeStatus"
                      @click="confirmShowPassword()"
                      :src="confirmImgSrc(confirmEyeStatus)"
                    />
                    <div
                      :class="
                        'helo-block alert alert-danger errorWidth errormsg-credential'
                      "
                      v-show="errors.has('Confirm Password')"
                    >{{ errors.first("Confirm Password") }}</div>
                  </b-form-group>
                </div>
              </div>
            </div>
          </v-card>
        </v-expansion-panel-content>
      </v-expansion-panel>
      <div class="row terms-conditions mt-5 lato-regular" v-if="termsConditionsValue.length > 0">
        <b-form-checkbox
          class
          id="terms"
          v-model="accepted"
          name="Terms and Conditions"
        >
          <!--:disabled="clickCheckbox"-->
          {{ $t("REGISTRATION_PAGE.TERMS_AND_CONDITIONS_CONTENT.YES_I_AGREE") }}
          <span
            class="terms-link"
            @click="terms_modal()"
          >
            {{
            $t(
            "REGISTRATION_PAGE.TERMS_AND_CONDITIONS_CONTENT.TERMS_AND_CONDITIONS"
            )
            }}
          </span>
        </b-form-checkbox>
      </div>
      <v-btn
        class="px-5 reset-button font-weight-bold py-2 mt-5 h-auto"
        @click="resetPage()"
      >{{ $t("Reset") }}</v-btn>
      <v-btn
        :class="
          isValid
            ? 'register-button px-5 py-2 mt-5'
            : 'disabled register-button px-5 py-2 mt-5'
        "
        @click="register()"
        v-on:keydown.enter.prevent
      >
        {{ $t("Register") }}&nbsp;&nbsp;
        <!-- <img
          class="right-arrow"
          src="@/assets/images/right-arrow.svg"
        />-->
      </v-btn>
    </div>
    <div v-if="regComplete" class="p-5">
      <div class="success-mark">
        <img class="tick" src="@/assets/images/checkMark.svg" />
      </div>
      <p
        class="exo-regular reg-success-text"
      >{{ $t("REGISTRATION_PAGE.ACCOUNT_REGISTRATION_SUCCESSFUL") }}</p>
      <p
        class="lato-regular reg-subtext w-50 m-auto"
      >{{ $t("REGISTRATION_PAGE.VERIFY_LINK_ON_YOUR_EMAIL") }}</p>
      <div class="row success-btn-row mb-5 mt-4">
        <div class="col">
          <b-button
            class="openSans-regular home-button w-100"
            @click="goToHomePage()"
          >{{ $t("BUTTONS.GO_TO_HOME") }}</b-button>
        </div>
        <!-- <div class="col p-0">
          <b-button class="openSans-regular continue-button w-100">GO TO LOGIN</b-button>
        </div>-->
      </div>
    </div>
    <b-modal
      v-model="otpModal"
      :no-close-on-backdrop="true"
      :no-close-on-esc="true"
      :ok-only="true"
      :hide-header="true"
      :hide-footer="true"
      centered
      id="otp-modal"
    >
      <div class="p-5 pt-0">
        <div>
          <p class="validate-otp-heading mt-3">{{ $t("REGISTRATION_PAGE.VALIDATE_OTP") }}</p>
          <p class="validate-otp-close">
            <img
              @click="optModalClose()"
              class="cursor-pointer"
              style="float:right;margin-top: -48px;height: 20px"
              src="@/assets/closeIcon.svg"
            />
          </p>
        </div>
        <hr class="hr-solid-otp-modal" />
        <p class="my-4 mobile-number-text-otp-modal">{{ otpToastResponse }}</p>
        <div class="row">
          <div class="col-9">
            <b-form-input
              v-model="form.otp"
              class="width-control-small lato-regular-input"
              @keydown="getOTPNumber($event)"
              type="number"
              v-on:keydown.e.prevent
              max="6"
            ></b-form-input>
          </div>
          <div class="col-3 p-0 m-0">
            <b-button
              class="verify-btn-otp-modal"
              :disabled="isOTPLength"
              @click="verifyOTP()"
            >{{ $t("BUTTONS.VERIFY") }}</b-button>
          </div>
        </div>
        <div data-v-16bac7d4="" style="background: rgb(233, 242, 249); margin: 5px 0px; padding: 5px; font-size: 12px; color: rgb(53, 58, 88);">
*For Indian mobile numbers, Kindly ensure you have not opted <b data-v-16bac7d4="">Do Not Disturb [DND]</b> 
option.To opt-out from Do Not Disturb [DND] List, SMS <b data-v-16bac7d4="" style="color: red;">START</b> to 
<b data-v-16bac7d4="" style="color: red;">9790864100</b> 
From Registered Mobile and will get Confirmation SMS instantly
</div>
        <button
          class="float-left resend mt-2"
          :disabled="disableResendOTPButton"
          @click="resendOTP()"
        >{{ $t("REGISTRATION_PAGE.RESEND_OTP") }} {{disableResendOTPButton && countdown > -1 && countdown < 61 ? '('+countdown+')' : ''}}</button>
      </div>
    </b-modal>
    <b-modal v-model="modalShow" id="res-error" title="Alert">
      <p class="my-4" style="text-align:center;">{{ lastResponse }}</p>
    </b-modal>
    <b-modal
      class="terms-modal"
      v-model="termsModal"
      id="terms"
      ok-title="I Accept"
      @ok="eventOk($event)"
      :hide-header="true"
      :ok-only="false"
      :no-close-on-backdrop="false"
      :no-close-on-esc="false"
      :hide-header-close="false"
      size="xl"
      centered
      scrollable
      no-fade
    >
      <span v-if="termsConditionsValue.length > 0">
        <c-TermsAndConditions :terms="termsConditionsValue" v-if="termsConditionsValue.length > 0" />
      </span>
    </b-modal>
    <w-loading-spinner :loadSpinner="loading" />
    <widgetModal
      :trigger="triggerModal"
      :text="lastResponse"
      :title="modalTitle"
      :centered="true"
      :dontCloseWhenClickedOutside="true"
      :dontCloseWhenEscapePressed="true"
      :dontShowCloseIcon="true"
      :modalbuttonStyle="true"
      :showAlert="alertModal"
      :showSuccess="successModal"
      @eventClose="changeModalSuccess()"
    />
  </div>
</template>

<script>
import DropDown from "../widgets/DropDown";
import TextInput from "../widgets/TextInput";
import multiSelect from "vue-multi-select";

import { DashboardService } from "../services/DashboardService.js";
const DashboardServices = new DashboardService();

import TermsAndConditions from "../components/registration/TermsAndConditions";
import VeeValidate from "vee-validate";
import { RegistrationService } from "../services/RegistrationService.js";
const RegisterService = new RegistrationService();
import RegisterTextInput from "../widgets/RegisterTextInput";
import LoadingSpinner from "../widgets/LoadingSpinner";
import widgetModal from "../widgets/newModalWidget";
export default {
  components: {
    "w-dropdown": DropDown,
    "w-text-input": RegisterTextInput,
    multiSelect,
    "c-TermsAndConditions": TermsAndConditions,
    "w-loading-spinner": LoadingSpinner,
    widgetModal
  },
  computed: {
    isOTPLength() {
      if ((this.form.otp + "").length > 0 && (this.form.otp + "").length < 6) {
        return true;
      } else if ((this.form.otp + "").length == 6) {
        return false;
      } else {
        return true;
      }
    },
    isValid() {
      if (this.form.identityNumber != null) {
        this.form.identityNumber = this.form.identityNumber.toUpperCase();
      }
      // this.verifyLength();
      // return {
      if (
        this.emailExists == false &&
        this.restrictEmail == false &&
        this.dunsNumberExist == false &&
        this.form.country &&
        this.form.nationalId &&
        this.form.organizationName &&
        this.form.coordinationPersonName &&
        this.form.designation &&
        this.form.mobileNumber &&
        this.form.email &&
        this.form.primaryBusiness &&
        this.form.specializedPrimaryCategory &&
        this.form.primaryCategory.length > 0 &&
        this.form.primarySubCategory.length > 0 &&
        this.identityNumberValidation == "Verified Successfully" &&
        // this.form.secondaryBusiness &&
        this.errors.items.length == 0 &&
        this.form.userName &&
        this.form.password &&
        this.form.reEnterPassword &&
        this.userNameDuplicate &&
        this.accepted &&
        !this.mobileNumberExists && 
        this.emailOTPVerified
      ) {
        if (this.form.secondaryBusiness != null) {
          return (
            this.form.secondaryCategory.length > 0 &&
            this.form.secondarySubCategory.length > 0
          );
        } else {
          return true;
        }
      }

      // };
    },    
    primaryBusinessTypesSelected() {
      return this.form.primaryBusinessTypesSelected;
    },
    secondaryBusinessTypesSelected() {
      return this.form.secondaryBusinessTypesSelected;
    },
    primaryBusiness() {
      return this.form.primaryBusiness;
    },
    secondaryBusiness() {
      return this.form.secondaryBusiness;
    }
  },
  watch: { 
    primaryBusinessTypesSelected: function(newVal, oldVal) {
      if ((this.form.primaryBusiness==3)) {
          this.getPrimaryCats()
      }
    },
    secondaryBusinessTypesSelected: function(newVal, oldVal) { 
      if ((this.form.secondaryBusiness==3)) {
        this.getSecondaryCats()
      }
    },
     deep: true
  },
  mounted() {
    window.localStorage.removeItem("eid");
    VeeValidate.Validator.extend("phone", {
      getMessage: field =>
        `The ${field} field must exactly ${this.mobileNumberSize}`,
      validate: value => {
        let urlRegex = new RegExp(`^[0-9][0-9]{${this.mobileNumberSize - 1}}$`);
        return urlRegex.test(value);
      }
    });
    this.getCountryDropDown();
    this.getPartnerList();
  },
  data() {
    return {
      serviceProvideBusinessTypes:[],
      biz: `Select Supplier if your are a Manufacturer or Retailer or Distributor.
Select Service Provider if you are any type of Contractor or Consultant or otherwise.`,
      disableResendOTPButton: false,
      clickCheckbox: true,
      modalShow: false,
      panAlreadyExist: false,
      panel: 0,
      lastResponse: "",
      otpModal: false,
      selectedCountry: "",
      triggerModal: false,
      successModal: false,
      alertModal: false,
      loading: false,
      form: {
        country: {
          // active: "Y",
          // applicableTag: "Y",
          // capital: 0,
          // countryCode: 100,
          // flag: null,
          // gmt: "GMT+05:30",
          // image: null,
          // insertedBy: 1,
          // insertedOn: "2019-08-08T06:48:47.273+0000",
          // isdCode: 91,
          // isoCode: "IN ",
          // languageCode: 11,
          // longDesc: "India",
          // nativeCurrencyCode: 72,
          // primaryCurrencyCode: 72,
          // secondaryCurrencyCode: 72,
          // shortDesc: "IND",
          // sizeOfMobileNumber: 10,
          // updatedBy: 1,
          // updatedTime: "2019-08-08T06:48:47.273+0000"
        },
        countryCode: null,
        nationalId: null,
        currencyCode: null,
        identityNumber: null,
        identityCode: null,
        organizationName: "",
        coordinationPersonName: "",
        designation: "",
        mobileNumber: "",
        email: "",
        url: "",
        primaryBusiness: null,
        secondaryBusiness: null,
        primaryCategory: [],
        secondaryCategory: [],
        primarySubCategory: [],
        secondarySubCategory: [],
        // User details
        userName: "",
        password: "",
        reEnterPassword: "",
        otp: "",
        duns: null,
        specializedPrimaryCategory: null,
        partner: null,
        primaryBusinessTypesSelected:[],
        secondaryBusinessTypesSelected:[],
        primaryBusinessType:[],
        secondaryBusinessType:[]
      },
      countries: [{ text: "Select One", value: null, disabled: true }],
      nationalIds: [{ text: "Select One", value: null, disabled: true }],
      primaryBusiness: [{ text: "Select One", value: null, disabled: true }],
      secondaryBusiness: [{ text: "Select One", value: null, disabled: true }],
      partnerList: [{ text: "Select One", value: null, disabled: true }],
      primaryCategory: [],
      primarySubCategory: [],
      secondaryCategory: [],
      secondarySubCategory: [],
      isdCode: " ",
      identityNumberValidation: null,
      selectedMultiCategories: [],
      regComplete: false,
      // User details globals
      eyeStatus: "hiddenPassword",
      confirmEyeStatus: "hiddenPassword",
      passwordType: "password",
      confirmPasswordType: "password",
      userNameDuplicate: false,
      otpToastResponse: "",
      wrongFormat: false,
      // Multi Select
      position: "top",
      options: {
        multi: true,
        groups: false,
        labelList: "elements",
        groupName: "title",
        cssSelected: option =>
          option.selected ? { "background-color": "#ffffff" } : ""
      },
      optionsForSubCategory: {
        multi: true,
        groups: false,
        labelList: "elements",
        groupName: "title",
        cssSelected: option =>
          option.selected ? { "background-color": "#ffffff" } : ""
      },
      btnLabelPrimaryCategory: values =>
        `Selected Categories (${values.length})`,
      btnLabelPrimarySubCategory: values =>
        `Selected Sub-Categories (${values.length})`,
      btnLabelSecondaryCategory: values =>
        `Selected Categories (${values.length})`,
      btnLabelSecondarySubCategory: values =>
        `Selected Sub-Categories (${values.length})`,
      btnLabelBusinessTypesPrimary: values =>
        `Selected Type (${values.length})`,
      btnLabelBusinessTypesSecondary: values =>
        `Selected Type (${values.length})`,
      accepted: false,
      termsModal: false,
      termsConditionsValue: [],
      mobileNumberExists: false,
      emailExists: false,
      restrictEmail: false,
      dunsNumberExist: false,
      showInvalidError: false,
      countdown: 30,
      int1:'',
      int2:'',
      otpSentToEmail:false,
      emailOTPVerified:false,
      invalidEmailPattern:true,
      emailOTP:'',      
        primaryBusinessTypes:[],
        secondaryBusinessTypes:[],
    };
  },
  methods: {
    getPrimaryCats(){
      this.serviceProvideBusinessTypes = this.form.primaryBusinessTypesSelected.map(x=>x.value)
      
      RegisterService.getPrimaryCategoryListmapped(this.form.primaryBusiness,this.serviceProvideBusinessTypes).then(resp => {
        if (resp) {
          let res = resp.response;
          this.primaryCategory = [];
          this.primarySubCategory = [];
          for (let i = 0; i < res.length; i++) {
            let data = {};
            data.name = res[i].longDesc;
            data.value = res[i].categoryCode;
            this.primaryCategory.push(data);
          }
        }
      })
        .catch(error => {
          this.loading = false
          this.primaryCategory = [];
          this.primarySubCategory = [];
        });
    },
    getSecondaryCats(){
      this.serviceProvideBusinessTypes = this.form.secondaryBusinessTypesSelected.map(x=>x.value)
      
      RegisterService.getPrimaryCategoryListmapped(this.form.secondaryBusiness,this.serviceProvideBusinessTypes)
        .then(resp => {
          if (resp) {
            let res = resp.response;
            this.secondaryCategory = [];
            for (let i = 0; i < res.length; i++) {
              let data = {};
              data.name = res[i].longDesc;
              data.value = res[i].categoryCode;
              this.secondaryCategory.push(data);
            }
          }
        })
        .catch(error => {
          this.loading = false
          this.secondaryCategory = [];
          this.secondarySubCategory = [];
        });
    },
    verifyEmailOTP() {
      var self = this
      var data={
          "email": this.EncodeUsingAES(this.form.email),
          "referenceNumber": this.emailOTP,
          "smsCode": 3
          } 
          self.otpSentToEmail = true;
      RegisterService.emailOTPVerify(data).then(resp => {
        let res = resp.response;
        if(res) {
          self.emailOTPVerified = true;
        } else {
          window.alert(resp.failureMessage)
        }
      })
        .catch(error => {
          window.alert('Something went wrong! Please contact support.')
        });    
    },
    sendOTPtoEmail(){
      var self = this
      var data={
          "companyCode": 1,
          "payLoad": this.EncodeUsingAES(this.form.organizationName+'~~~'+this.form.email),
          "smsCode": 3
          }
      RegisterService.emailOTPsend(data).then(resp => {
        let res = resp.response;
        if(res.message=="OTP sent successfully"){
          window.alert("OTP has been sent to " + this.form.email + ". Kindly enter OTP and verify.")
          self.otpSentToEmail = true;
        } else {
          window.alert(resp.failureMessage)
        }
      })
        .catch(error => {
          window.alert('Something went wrong! Please contact support.')
        });
    
    },
    mobileValidationObj(){
      if(this.form.countryCode=='100'){
        return {required: true, regex_mobile_number: true, length: this.mobileNumberSize}
      } else {
        return {required: true, min:6}
      }     
    },
    foreignIdValidation(){
      this.form.identityNumber && this.form.identityNumber.trim().length 
      > 2 ? this.identityNumberValidation = 'Verified Successfully' : this.identityNumberValidation == ''
    },
    getCountryDropDown() {
      RegisterService.getCountries().then(resp => {
        let res = resp.response;
        for (let i = 0; i < res.length; i++) {
          this.countries.push({
            text: res[i].longDesc,
            value: res[i]
          });
          if(res[i].longDesc == "India"){
          this.selectedCountry = res[i];
          this.getCountry(res[i]);
          }
        }
      });
    },
    getCountry(event) {
      if (event) {
        this.form.nationalId = null
        this.form.identityNumber = null
        this.form.country = event;this.selectedCountry = event;
        this.form.countryCode = event.countryCode;
        //this.selectedCountry=
        //(this.countries).slice().filter(x=>x.value && x.value.countryCode && x.value.countryCode==event.countryCode)[0].value;
        this.form.currencyCode = event.nativeCurrencyCode;
        this.isdCode = "+" + event.isdCode;
        this.mobileNumberSize = event.countryCode == '100' ? event.sizeOfMobileNumber : 15;
        this.nationalIds = [
          { text: "Select One", value: null, disabled: true }
        ];
        RegisterService.getNationalId(event.countryCode).then(resp => {
          if (resp.failureMessage == "") {
            if (resp.response) {
              let res = resp.response;
              for (let i = 0; i < res.length; i++) {
                this.nationalIds.push({
                  text: res[i].longDesc,
                  value: res[i].longDesc,
                  response: res[i]
                });
              }
            }
          }
          // this.nationalId =
        });
      }
    },
    optModalClose() {
      // this.regComplete = true;
      this.goToHomePage();
    },
    checkStatus(nameOfPanel) {
      if (nameOfPanel == "kyc") {
        if (
          this.form.country != null &&
          this.form.nationalId != null &&
          this.form.identityNumber != null &&
          this.form.identityNumber != "" &&
          this.identityNumberValidation == "Verified Successfully" &&
          this.form.organizationName != "" &&
          this.form.organizationName != null
        ) {
          if (this.form.duns != null) {
            if (this.errors.items.length > 0) {
              for (let i = 0; i < this.errors.items.length; i++) {
                if (this.errors.items[i].field == "DUNS Number") {
                  return "progress-tick-orange";
                } else {
                  return "progress-tick-green";
                }
              }
            } else {
              if (this.dunsNumberExist == true) {
                return "progress-tick-orange";
              }
              return "progress-tick-green";
            }
          } else {
            return "progress-tick-green";
          }
        } else {
          return "progress-tick-orange";
        }
      } else if (nameOfPanel == "contact_details") {
        if (
          this.form.coordinationPersonName != "" &&
          this.form.designation != "" &&
          this.form.mobileNumber != "" &&
          this.form.email != "" && 
          this.emailOTPVerified == true
        ) {
          if (this.errors.items.length > 0) {
            for (let i = 0; i < this.errors.items.length; i++) {
              if (
                this.errors.items[i].field == "Email" ||
                this.errors.items[i].field == "Mobile Number"
              ) {
                return "progress-tick-orange";
              } else {
                return "progress-tick-green";
              }
            }
          } else {
            if (this.emailExists == true || this.restrictEmail == true) {
              return "progress-tick-orange";
            } else {
              return "progress-tick-green";
            }
          }
        } else {
          return "progress-tick-orange";
        }
      } else if (nameOfPanel == "business_profile") {
        if (
          this.form.partner != null &&
          this.form.primaryBusiness != null &&
          this.form.primaryCategory.length > 0 &&
          this.form.primarySubCategory.length > 0 &&
          this.form.specializedPrimaryCategory != null
        ) {
          if (this.form.secondaryBusiness != null) {
            if (
              this.form.secondaryCategory.length > 0 &&
              this.form.secondarySubCategory.length > 0
            ) {
              return "progress-tick-green";
            } else {
              return "progress-tick-orange";
            }
          } else {
            return "progress-tick-green";
          }
        } else {
          return "progress-tick-orange";
        }
      } else if (nameOfPanel == "credentials") {
        if (
          this.form.userName != "" &&
          this.userNameDuplicate &&
          this.form.password != "" &&
          this.form.reEnterPassword != ""
        ) {
          if (this.errors.items.length > 0) {
            for (let i = 0; i < this.errors.items.length; i++) {
              if (
                this.errors.items[i].field == "Password" ||
                this.errors.items[i].field == "Confirm Password"
              ) {
                return "progress-tick-orange";
              } else {
                return "progress-tick-green";
              }
            }
          } else {
            return "progress-tick-green";
          }
          // return "progress-tick-green";
        } else {
          return "progress-tick-orange";
        }
      }
    },
    goToHomePage() {
      this.$router.push("/home");
    },
    getPartnerList() {
      RegisterService.getPartnerList().then(resp => {
        let res = resp.response;
        for (let i = 0; i < res.length; i++) {
          this.partnerList.push({
            text: res[i].name,
            value: res[i].companyCode
          });
        }
      });
    },
    verifyIdentityCard(event) { 
      var idValue = this.form.identityNumber.toUpperCase();
      if(this.form.countryCode != 100) {
      if(idValue.length < 5) {
        this.triggerModal = true;
            this.alertModal = true;
            this.lastResponse = "Id card value should be atleast 5 characters";
            return
      }  
      if(idValue.length > 30) {
        this.triggerModal = true;
            this.alertModal = true;
            this.lastResponse = "Id card value should be less than 30 characters";
            return
      } 
      if(idValue.trim().indexOf('--') > -1) {
        this.triggerModal = true;
            this.alertModal = true;
            this.lastResponse = "Id card value should not contain repeated hyphens";
            return
      }
      if(idValue.trim().indexOf('  ') > -1) {
        this.triggerModal = true;
            this.alertModal = true;
            this.lastResponse = "Id card value should not contain repeated spaces";
            return
      }
      if(idValue.trim()=='') {
        this.triggerModal = true;
            this.alertModal = true;
            this.lastResponse = "Id card value should be valid";
            return
      }
      }
      var idType = this.form.nationalId;
      RegisterService.checkIdentityCard(idValue, idType).then(resp => {
        if (resp) {

          if (resp.failureMessage !=''){
            this.showInvalidError = true;
            // this.modalShow = true;
            this.triggerModal = true;
            this.alertModal = true;
            this.lastResponse = resp.failureMessage
          }

          if (resp.response == "") {
            this.showInvalidError = false;
            this.identityNumberValidation = resp.failureMessage;
            this.verifiedAll(true);
          } else if (resp.response == true) {
            this.identityNumberValidation = "Verified Successfully";
          } else if (resp.response.toLowerCase().includes("already exists")) {
            // this.identityNumberValidation = "Verified but Already exists";
            this.identityNumberValidation = null;
            this.showInvalidError = true;
            // this.modalShow = true;
            this.triggerModal = true;
            this.alertModal = true;
            this.panAlreadyExist = true;
            this.lastResponse = resp.response;
            // this.identityNumberValidation = resp.response;
            this.verifiedAll(true);
          } 
        }
      })
        .catch(error => {
          window.alert('Something went wrong! Check ' +this.form.nationalId)
        });
    },
    verifyLength() {
      if (this.form.identityNumber != null) {
        let actualLength = this.form.identityNumber.toString().length;
        if (actualLength == this.minimumDigitsForValidation) {
          return false;
        } else {
          return true;
        }
      } else return true;
    },
    verifiedAll(status) {
      if (status == null) return false;
      else return status;
    },
    defaultMsg(event) {
      this.showInvalidError = true;
      if (event.target.value.length >= this.minimumDigitsForValidation) {
        event.preventDefault();
        return false;
      }
    },
    validateInput(event) {
      if (event.target.value.length >= 27) {
        event.preventDefault();
        return false;
      }
    },
    validatePassword(event) {
      if (event.target.value.length >= 32) {
        event.preventDefault();
        return false;
      }
    },
    getNationalId(event) {
      this.identityNumberValidation = null;
      this.form.identityNumber = null;
      this.form.nationalId = event;
      this.nationalIds.forEach(Element => {
        if (Element.text == event) {
          this.form.identityCode = Element.response.idCardCode;
          this.minimumDigitsForValidation = Element.response.numberOfDigit;
        }
      });
    },
    getCoordinationPersonName(event) {
      this.form.coordinationPersonName = event;
    },
    getPhoneNumber(event) {
      this.mobileNumberExists = false;
      this.form.mobileNumber = event;

      if ((event.length == this.mobileNumberSize && this.form.countryCode == '100') || event.length > 6) {
        RegisterService.mobileNumberUniqueness(this.form.mobileNumber).then(
          resp => {
          if (resp.failureMessage.toLowerCase().indexOf("already exists")>-1) {
              this.mobileNumberExists = true;
            }
          }
        );
      }
    },
    getOrganizationName(event) {
      this.form.organizationName = event;
    },
    getDesignation(event) {
      this.form.designation = event;
    },
    getURL(event) {
      this.form.url = event.toLowerCase();
    },
    getDunsNumber(event) {
      this.dunsNumberExist = false;
      this.form.duns = event;
      if (this.form.duns.length == 9) {
        RegisterService.checkDunsCode(event).then(resp => {
          if (resp.failureMessage.toLowerCase().indexOf("already exists")>-1) {
            this.dunsNumberExist = true;
          }
        });
      } else {
        this.dunsNumberExist = false;
      }
    },
    getEmail(event) {
      this.emailExists = false;
      this.restrictEmail = false;
      this.emailOTPVerified = false;
      this.otpSentToEmail = false
      // this.form.email = event;
      this.form.email = event.toLowerCase();
      let emailRegex = new RegExp("^[a-zA-Z0-9+._-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,6}$");

      if (emailRegex.test(event.toLowerCase())) {
        this.invalidEmailPattern = false;
        RegisterService.emailUniqueness(this.form.email).then(resp => {
          if (resp.failureMessage.toLowerCase().indexOf("already exists")>-1) {
            this.emailExists = true;
          }
        });
        var domain = event.replace(/.*@/, "");
        var domainName = domain.split(".");
        if (domainName[0]) {
          RegisterService.restrictEmail(domainName[0]).then(resp => {
            if (resp.response == false) {
              this.restrictEmail = true;
            }
          });
        }
      } else {
        this.invalidEmailPattern = true;
      }
    },
    getprimaryBusinessTypes(event){
      this.form.primaryBusinessTypesSelected = event
      var arr = []
      if(this.form.primaryBusiness == 2){
        arr.push(this.form.primaryBusinessTypesSelected)
      } 
      RegisterService.getPrimaryCategoryListmapped(this.form.primaryBusiness,arr).then(resp => {
        if (resp) {
          let res = resp.response;
          this.primaryCategory = [];
          this.primarySubCategory = [];
          for (let i = 0; i < res.length; i++) {
            let data = {};
            data.name = res[i].longDesc;
            data.value = res[i].categoryCode;
            this.primaryCategory.push(data);
          }
        }
      });
    },
    getSecondaryBusinessTypes(event){
      this.form.secondaryBusinessTypesSelected = event    
      var arr = []
      if(this.form.secondaryBusiness == 2){
        arr.push(this.form.secondaryBusinessTypesSelected)
      } 
      RegisterService.getPrimaryCategoryListmapped(this.form.secondaryBusiness,arr)
        .then(resp => {
          if (resp) {
            let res = resp.response;
            this.secondaryCategory = [];
            for (let i = 0; i < res.length; i++) {
              let data = {};
              data.name = res[i].longDesc;
              data.value = res[i].categoryCode;
              this.secondaryCategory.push(data);
            }
          }
        })
        .catch(error => {
          this.secondaryCategory = [];
          this.secondarySubCategory = [];
        });
    },
    getPartner(event) {
      this.form.partner = event;  
      this.primaryBusiness = [];  
      this.secondaryBusiness = [];    
      this.primaryBusinessTypes = [];
      this.secondaryBusinessTypes = [];
      this.form.primaryBusinessTypesSelected = [];
      this.form.secondaryBusinessTypesSelected = [];
      RegisterService.getBussiness(event).then(resp => {
        let res = resp.response;
        for (let i = 0; i < res.length; i++) {
          if(res[i].categoryCode != 5){
          this.primaryBusiness.push({
            text: res[i].longDesc,
            value: res[i].categoryCode
          });
          }
        }
      });
    },
    getPrimaryBusiness(event) {
      this.form.primaryBusiness = event;
      this.form.specializedPrimaryCategory = null;
      this.getTerms(event, "primary");
      this.primaryBusinessTypes = [];
      this.secondaryBusinessTypes = [];
      this.form.primaryBusinessTypesSelected = [];
      this.form.secondaryBusinessTypesSelected = [];
      DashboardServices.getBusinessTypes(
        this.form.partner,
        this.form.primaryBusiness
      ).then(res => {        
        var list = res.response
        for (let i = 0; i < list.length; i++) {    
        if(this.form.primaryBusiness==2){
          this.primaryBusinessTypes.push({
            text: list[i].longDesc,
            value: list[i].id
          });          
        } else if (this.form.primaryBusiness==3){
          this.primaryBusinessTypes.push({
            name: list[i].longDesc,
            value: list[i].id
          });
        }
          }
      });
      
      RegisterService.getBussiness(this.form.partner).then(resp => {
        let res = resp.response;
        this.secondaryBusiness = [
          { text: "Select One", value: null, disabled: true }
        ];
        this.secondaryCategory = [];
        this.secondarySubCategory = [];
        for (let i = 0; i < res.length; i++) {
          if (this.form.primaryBusiness == res[i].categoryCode) {
          } else {
            if(res[i].categoryCode != 5){
            this.secondaryBusiness.push({
              text: res[i].longDesc,
              value: res[i].categoryCode
            });
            }
          }
        }
      });

    },
    getPrimaryCategory() {
      this.form.specializedPrimaryCategory = null;
      if (this.form.primaryCategory.length > 0) {
        var categoryData = [];
        this.form.primaryCategory.forEach(category => {
          categoryData.push(category.value);
        });

        RegisterService.getPrimarySubCategories(categoryData).then(resp => {
          let res = resp.response;
          this.primarySubCategory = [];
          for (let i = 0; i < res.length; i++) {
            let data = {};
            data.name = res[i].longDesc;
            data.value = res[i].categoryCode;
            this.primarySubCategory.push(data);
          }
        });
      } else {
        this.primarySubCategory = [];
      }
    },
    getCategoryForApproval(event) {
      this.form.specializedPrimaryCategory = event;
    },
    getSecondaryBussiness(event) {
      this.form.secondaryBusiness = event;
      this.getTerms(event, "secondary");
      
      this.secondaryBusinessTypes = [];
      this.form.secondaryBusinessTypesSelected = [];
      DashboardServices.getBusinessTypes(
        this.form.partner,
        this.form.secondaryBusiness
      ).then(res => {        
        var list = res.response
        for (let i = 0; i < list.length; i++) {    
        if(this.form.secondaryBusiness==2){
          this.secondaryBusinessTypes.push({
            text: list[i].longDesc,
            value: list[i].id
          });  
        } else if (this.form.secondaryBusiness==3){
          this.secondaryBusinessTypes.push({
            name: list[i].longDesc,
            value: list[i].id
          });
        }
      }
      });
    },
    getSecondaryCategory() {
      if (this.form.secondaryCategory.length > 0) {
        var categoryData = [];
        this.form.secondaryCategory.forEach(category => {
          categoryData.push(category.value);
        });

        RegisterService.getSecondarySubCategories(categoryData).then(resp => {
          let res = resp.response;
          this.secondarySubCategory = [];
          for (let i = 0; i < res.length; i++) {
            let data = {};
            data.name = res[i].longDesc;
            data.value = res[i].categoryCode;
            this.secondarySubCategory.push(data);
          }
        });
      } else {
        this.secondarySubCategory = [];
      }
    },
    specializedPrimaryCategory(categories) {
      let categoryList = [{ text: "Select One", value: null, disabled: true }];
      categories.forEach(category => {
        let data = {};
        data.text = category.name;
        data.value = category.value;
        categoryList.push(data);
      });
      return categoryList;
    },
    getTerms(business, type) {
      RegisterService.getTerms(this.form.partner, business).then(resp => {
        if (resp.response) {
          this.termsConditionsValue = [];
          this.termsConditionsValue.push(
            resp.response.replace(/\n/g, "<br />")
          );
          // this.termsConditionsValue.splice(
          //   0,
          //   1,business + '<br>' +
          //   resp.response.replace(/\n/g, "<br />")
          // );
        } else {
          this.termsConditionsValue = [];
        }
      });

      // if (type === "primary") {
      //   if (business != null) {
      //     var businessName = "";
      //     this.primaryBusiness.forEach(avlBusiness => {
      //       if (this.form.primaryBusiness == avlBusiness.value) {
      //         businessName = avlBusiness.text;
      //       }
      //     });

      //     if (this.form.primaryBusiness == this.form.secondaryBusiness) {
      //       // this.termsConditionsValue.slice(1);
      //       RegisterService.getTerms(this.form.partner, business).then(resp => {
      //         if (resp.response) {
      //           this.termsConditionsValue = [];
      //           this.termsConditionsValue.push(
      //             businessName + "<br>" + resp.response.replace(/\n/g, "<br />")
      //           );
      //           // this.termsConditionsValue.splice(
      //           //   0,
      //           //   1,business + '<br>' +
      //           //   resp.response.replace(/\n/g, "<br />")
      //           // );
      //         } else {
      //           this.termsConditionsValue = [];
      //         }
      //       });
      //     } else {
      //       this.termsConditionsValue.slice(1);
      //       RegisterService.getTerms(this.form.partner, business).then(resp => {
      //         if (resp.response) {
      //           this.termsConditionsValue.splice(
      //             0,
      //             1,
      //             businessName + "<br>" + resp.response.replace(/\n/g, "<br />")
      //           );
      //         } else {
      //           this.termsConditionsValue = [];
      //         }
      //       });
      //     }
      //   } else {
      //     this.termsConditionsValue.splice(0, 1);
      //   }
      // } else {
      //   if (business != null) {
      //     var businessName = "";
      //     this.secondaryBusiness.forEach(avlBusiness => {
      //       if (this.form.secondaryBusiness == avlBusiness.value) {
      //         businessName = avlBusiness.text;
      //       }
      //     });
      //     RegisterService.getTerms(this.form.partner, business).then(resp => {
      //       if (resp.response) {
      //         this.termsConditionsValue.splice(
      //           1,
      //           1,
      //           businessName + "<br>" + resp.response.replace(/\n/g, "<br />")
      //         );
      //       } else {
      //         this.termsConditionsValue = [];
      //       }
      //     });
      //   } else {
      //     this.termsConditionsValue.splice(1, 1);
      //   }
      // }
    },
    terms_modal() {
      this.accepted = true;
      this.termsModal = true;
      this.clickCheckbox = true;
    },
    eventOk() {
      this.accepted = true;
      this.termsModal = true;
      this.clickCheckbox = true;
    },
    // User details
    goBack() {
      this.$emit("goBack", event);
    },
    checkUserName() {
      var format = /[ !@#$%^&*()+\=\[\]{};':"\\|,.<>\/?]/;
      if (!format.test(this.form.userName)) {
        if (this.form.userName.length > 0 && this.form.userName.length < 27) {
          RegisterService.userNameUniquness(this.form.userName)
            .then(res => {
              if (res.response) {
                this.userNameDuplicate = true;
              } else {
                this.userNameDuplicate = false;
              }
            })
            .catch(err => {
              this.userNameDuplicate = false;
            });
        } else {
          this.userNameDuplicate = true;
          this.wrongFormat = true;
        }
      }
    },
    showPassword() {
      if (this.eyeStatus === "hiddenPassword") {
        this.passwordType = "text";
        this.eyeStatus = "showPassword";
      } else {
        this.passwordType = "password";
        this.eyeStatus = "hiddenPassword";
      }
    },
    confirmShowPassword() {
      if (this.confirmEyeStatus === "hiddenPassword") {
        this.confirmPasswordType = "text";
        this.confirmEyeStatus = "showPassword";
      } else {
        this.confirmPasswordType = "password";
        this.confirmEyeStatus = "hiddenPassword";
      }
    },
    imgSrc(icon) {
      if (this.eyeStatus == "showPassword") {
        icon = "showPassword";
        var images = require.context("@/assets/images/", false, /\.svg$/);
        return images("./" + icon + ".svg");
      } else if (this.eyeStatus == "hiddenPassword") {
        icon = "hiddenPassword";
        var images = require.context("@/assets/images/", false, /\.svg$/);
        return images("./" + icon + ".svg");
      }
    },
    confirmImgSrc(icon) {
      if (this.confirmEyeStatus == "showPassword") {
        icon = "showPassword";
        var images = require.context("@/assets/images/", false, /\.svg$/);
        return images("./" + icon + ".svg");
      } else if (this.confirmEyeStatus == "hiddenPassword") {
        icon = "hiddenPassword";
        var images = require.context("@/assets/images/", false, /\.svg$/);
        return images("./" + icon + ".svg");
      }
    },
    // terms_modal() {
    //   this.accepted = true;
    //   this.termsModal = true;
    // },
    // Register API Call
    register() {
      var self = this
      this.loading = true;
      this.form.otp = null;
      let registrationForm = {
        shortDesc: "Sample Partner Short Desc",
        longDesc: "",
        countryCode: null,
        website: "",
        primaryBusiness: null,
        primaryCategory: [],
        primarySubCategory: [],
        secondaryBusiness: null,
        secondaryCategory: [],
        secondarySubCategory: [],
        companyTypeCode: null,
        constitution: null,
        currencyCode: null,
        contactContactName: "",
        contactDesignation: "",
        contactTelPhoneNumber: 2231,
        contactMobileNumber: null,
        contactFax: "123123123",
        contactEmail: "",
        loginName: "",
        password: "",
        idCardCode: null,
        idCardValue: "",
        companyCode: null,
        specializedPrimaryCategory: null
      };
      
      if(!(/^[A-Za-z0-9&-\s]*$/.test(this.form.organizationName))) {
        window.alert('Organization name cannot contain special characters except & or -')
        this.loading = false;
        return;
      }
      if(!(/^([a-zA-Z0-9-]+\s?)*$/.test(this.form.nationalId))) {
        window.alert('National Id Names cannot contain special characters')
        this.loading = false;
        return;
      }
      if(!(/^[A-Za-z0-9-\s]*$/.test(this.form.identityNumber))) {
        window.alert('National Id number cannot contain special characters')
        this.loading = false;
        return;
      }
      registrationForm.longDesc = this.form.organizationName;
      registrationForm.countryCode = this.form.countryCode;
      registrationForm.website = this.form.url;
      registrationForm.primaryBusiness = this.form.primaryBusiness;
      registrationForm.dunsNumber = this.form.duns;
      registrationForm.secondaryBusiness = this.form.secondaryBusiness;
      this.form.primaryCategory.forEach(element => {
        registrationForm.primaryCategory.push(element.value);
      });
      this.form.primarySubCategory.forEach(element => {
        registrationForm.primarySubCategory.push(element.value);
      });
      this.form.secondaryCategory.forEach(element => {
        registrationForm.secondaryCategory.push(element.value);
      });
      this.form.secondarySubCategory.forEach(element => {
        registrationForm.secondarySubCategory.push(element.value);
      });
      registrationForm.currencyCode = this.form.currencyCode;
      registrationForm.contactContactName = this.form.coordinationPersonName;
      registrationForm.contactDesignation = this.form.designation;
      registrationForm.contactMobileNumber = this.form.mobileNumber;
      registrationForm.contactEmail = this.form.email;
      registrationForm.loginName = this.form.userName;
      registrationForm.password = this.form.password;
      registrationForm.idCardCode = this.form.identityCode;
      registrationForm.idCardValue = this.form.identityNumber;
      registrationForm.companyCode = this.form.partner;
      registrationForm.specializedPrimaryCategory = this.form.specializedPrimaryCategory;
      var arr1= []
      var arr2= []
      registrationForm.primaryBusinessType = []
      registrationForm.secondaryBusinessType = []
      if(self.form.primaryBusiness==2){
        arr1.push(this.form.primaryBusinessTypesSelected)
       registrationForm.primaryBusinessType = arr1
      }if(self.form.primaryBusiness==3){
       registrationForm.primaryBusinessType = this.form.primaryBusinessTypesSelected.map(x=>x.value)
      }if(self.form.secondaryBusiness==2){
        arr2.push(this.form.secondaryBusinessTypesSelected)
       registrationForm.secondaryBusinessType = arr2
      }if(self.form.secondaryBusiness==3){
       registrationForm.secondaryBusinessType = this.form.secondaryBusinessTypesSelected.map(x=>x.value)
      }

      if((registrationForm.primaryBusinessType.indexOf(7) > -1 || registrationForm.primaryBusinessType.indexOf(4) > -1) 
      && registrationForm.primaryBusinessType.length > 1) {
        window.alert("Business type 'Professional Services / Consultants' and 'Regular Labour Sub-Contractor' cannot be chosen along with other business types. Select only one of them or uncheck it continue.")
        return false;
     } 
     if((registrationForm.secondaryBusinessType.indexOf(7) > -1 || registrationForm.secondaryBusinessType.indexOf(4) > -1) 
     && registrationForm.secondaryBusinessType.length > 1) {
        window.alert("Business type 'Professional Services / Consultants' and 'Regular Labour Sub-Contractor' cannot be chosen along with other business types. Select only one of them or uncheck it continue.")
        return false;
     }
      console.log(registrationForm.primaryBusinessType)
      console.log(registrationForm.secondaryBusinessType)
      if(registrationForm.primaryCategory.length > 5){
        window.alert("Maximum 5 categories are allowed in Primary Category list. You can add more later if required.")
        return false;
      }
      if(registrationForm.secondaryCategory.length > 5){
        window.alert("Maximum 5 categories are allowed in Secondary Category list. You can add more later if required.")
        return false;
      }
      RegisterService.registerPartner(registrationForm).then(resp => {
        if (resp.status=="SUCCESS") {
          if(resp.response == "PAN already exists"){
            window.alert("Company ID already exists or invalid.")
            return;
          }
          this.loading = true;
          // this.$refs["otp-modal"].show();
          this.getOTP();
        } else {
           window.alert(resp.failureMessage)
         }
      })
        .catch(error => {
          if(error.failureMessage != ''){
            window.alert(error.failureMessage)
          } else {
            window.alert('Something went wrong!')
          }
        });;
    },
    resetPage() {
      location.reload();
      // this.$router.go(this.$router.currentRoute);
      // this.form.reset();
      // Reset();
    },
    getOTP() {
      RegisterService.getOTPbyloginName(this.form.userName).then(res => {
        if (res.response) {
          this.loading = false;          
      var self = this
      this.disableResendOTPButton = true;
      this.countdown=30
      this.int1 = setInterval(function(){self.countdown = self.countdown-1},1000)
      setTimeout(() => {
        this.disableResendOTPButton = false;
        clearInterval(self.int1)
      }, 30000);
          this.otpModal = true;
          var mobileNumber = this.DecodeUsingAES(res.response.mobileNo);
          var firstTwo = mobileNumber.substring(0, 2);
          var firstSeven = firstTwo.concat("*****");
          var starsMobile = firstSeven.concat(mobileNumber.substring(7, 10));
          var otpMessage =
            "One Time Password(OTP) has been sent to Registered Email and Mobile " +
            starsMobile +
            " To set Password";
            if(this.form.countryCode!='100'){
              otpMessage = "One Time Password(OTP) has been sent to Registered Email Id "+ this.form.email
            }
          this.otpToastResponse = otpMessage;
          // this.form.otp = res.response.otp;
        }
      });
    },
    getOTPNumber(event) {
      if (
        event.target.value.length < 6 ||
        event.keyCode == 46 ||
        event.keyCode == 8 ||
        event.keyCode == 37 ||
        event.keyCode == 39 ||
        event.keyCode == 9
      ) {
        this.form.otp = event.target.value;
      } else {
        event.preventDefault();
      }
    },
    DecodeUsingAES(value) {
      var CryptoJS = require("crypto-js");
      if (value === undefined || value === null) {
        return "";
      } else {
        try {
          value = value.split(" ").join("+");
          const keys = atob(process.env.VUE_APP_E_K)
          const key = CryptoJS.enc.Utf8.parse(keys);
          const vectorIV = CryptoJS.enc.Utf8.parse(keys);
          const decrypted = CryptoJS.AES.decrypt(value, key, {
            keySize: 128 / 8,
            iv: vectorIV,
            mode: CryptoJS.mode.CBC,
            padding: CryptoJS.pad.Pkcs7
          });
          return decrypted.toString(CryptoJS.enc.Utf8);
        } catch (e) {
          throw e;
        }
      }
    },
    verifyOTP() {
      if (this.form.otp) {
        let data = {};
        data.loginName = this.form.userName;
        data.otp = this.form.otp;
        RegisterService.verifyOTP(data).then(res => {
          if (res.response == true) {
            this.verifiedStatus = true;
            this.otpModal = false;
            RegisterService.verifyEmail(this.form.userName).then(res => {
              this.regComplete = true;
            });
          } else {
            this.modalShow = true;
            this.lastResponse = res.failureMessage;
          }
        });
      }
    },
    resendOTP() {
      var self = this
      this.disableResendOTPButton = true;
      this.countdown=30
      this.int2 = setInterval(function(){self.countdown = self.countdown-1},1000)
      setTimeout(() => {
        this.disableResendOTPButton = false;
        clearInterval(self.int2)
      }, 30000);
      var smscode = 1;
      var username = this.EncodeUsingAES(this.form.userName);
      RegisterService.resendOTP(username, smscode).then(res => {
        if (res.failureMessage == "") {
          // this.form.otp = res.response.otp;
            this.modalShow = true;
            this.lastResponse = res.response;
        } else {
            this.modalShow = true;
            this.lastResponse = res.failureMessage;
          }
      });
    },
    EncodeUsingAES(value) {
      var CryptoJS = require("crypto-js");
      if (value === undefined || value === null) {
        return "";
      } else {
        const keys = atob(process.env.VUE_APP_E_K)
        const key = CryptoJS.enc.Utf8.parse(keys);
        const vectorIV = CryptoJS.enc.Utf8.parse(keys);
        const encrypted = CryptoJS.AES.encrypt(
          CryptoJS.enc.Utf8.parse(value.toString()),
          key,
          {
            keySize: 128 / 8,
            iv: vectorIV,
            mode: CryptoJS.mode.CBC,
            padding: CryptoJS.pad.Pkcs7
          }
        );
        return encrypted.toString();
      }
    },
    changeModalSuccess() {
      this.triggerModal = false;
      this.alertModal = false;
    }
  }
};
</script>

<style scoped>
.disabled {
  pointer-events: none;
  cursor: default;
  color: white !important;
  cursor: not-allowed !important;
  opacity: 0.5;
}
.register-button {
  width: 197.7px;
  height: 40px !important;
  border-radius: 2px;
  font-family: "Source Sans Pro", sans-serif !important;
  background-color: #1579ab !important;
  font-size: 16px;
  font-weight: normal !important;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.25;
  letter-spacing: normal;
  text-align: center;
  color: white;
  text-transform: none;
  box-shadow: none !important;
  cursor: pointer;
}
.background-bg {
  background-color: #f8f8f8;
  height: auto;
}
.back-div {
  background-color: white;
  /* font-family: "Titillium Web", sans-serif; */
  font-family: "Source Sans Pro", sans-serif;
  font-size: 20px;
  font-weight: 600;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.55;
  letter-spacing: normal;
  text-align: left;
  color: #002d72;
}
.back-div-text {
  width: 90%;
  margin: 0 auto;
}
.back-div-text-style {
  cursor: pointer;
  width: fit-content;
}
.partner-registration-heading {
  width: 90%;
  margin: 0 auto;
  /* font-family: "Titillium Web", sans-serif; */
  font-family: "Source Sans Pro", sans-serif;
  font-size: 25px;
  line-height: 1.44;
  letter-spacing: 0.3px;
  text-align: left;
  color: #002d72;
}
/* DESIGN FROM ORGANIZATION DETAILS PAGE */

.errorWidth {
  font-size: 12px !important;
  width: 80% !important;
  padding: 2px !important;
  /* margin-left: 30px !important; */
}
.errorWidthSmall {
  font-size: 12px !important;
  width: 80% !important;
  padding: 2px !important;
  margin: 0 auto;
  /* margin-left: 30px !important; */
}
.form-row {
  padding-left: 15%;
}
.was-validated .form-control:invalid,
.form-control.is-invalid {
  background-image: none;
}
.card-layout {
  border: 1px solid #bababa;
  box-shadow: none;
  border-radius: 10px;
  width: 90%;
  margin: 0 auto;
}
.card-details-heading {
  font-size: 25px;
  color: #002d72;
}
.group-heading {
  font-size: 16px;
  font-weight: normal;
  color: #071b31;
}
.label {
  text-align: right;
}
.width-control {
  width: 100%;
  /* margin-left: 30px; */
  height: auto !important;
  margin: 0 auto;
}
.width-control-small {
  width: 100%;
  margin: 0 auto;
}
/* margin-left: 30px; */
/* height: auto !important; */
/* margin: 0 auto; */
/* } */
.custom-multiselect-style {
  width: 80%;
  margin: 0 auto;
}
.field-headings {
  font-size: 12px !important;
  font-weight: bold !important;
  letter-spacing: 0.2px !important;
  color: #484848 !important;
  /* margin-bottom: 42px; */
  margin-bottom: 20px !important;
}
.field-p-primary-category {
  font-size: 12px !important;
  letter-spacing: 0.2px !important;
  color: #484848 !important;
}
.identity-row {
  margin: 0 auto !important;
  width: 100%;
}
.col-form-label {
  height: 100%;
  /* line-height: 64px !important; */
  padding: 0;
  /* width: 80%; */
  text-align: start;
}
.stepper-spacing {
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.16);
}
.verify-col {
  padding-left: 0;
  padding-right: 0;
  margin: 0 0 auto 0px;
}
.verify-btn {
  width: fit-content !important;
  background: none !important;
  font-size: 14px !important;
  font-weight: bold !important;
  line-height: 1.2 !important;
  letter-spacing: 0.8px !important;
  color: #0843a8 !important;
  border: none !important;
  padding-left: 0;
  padding-right: 0;
  height: 35px !important;
}
.invalid-id {
  color: red;
}
.verified-already-exists-id {
  color: orange;
}
.verify-btn-success {
  width: fit-content !important;
  background: none !important;
  font-size: 14px !important;
  font-weight: bold !important;
  line-height: 1.2 !important;
  letter-spacing: 0.8px !important;
  color: #28b915 !important;
  border: none !important;
  padding-left: 0;
  padding-right: 0;
  line-height: 35px !important;
}

/* END OF DESIGN FROM ORGANIZATION DETAILS PAGE */

/* User Details page */
.was-validated .form-control:invalid,
.form-control.is-invalid {
  background-image: none;
}
.width-control {
  width: 100%;
  /* margin: 0 auto; */
  /* height: 64px; */
}
.width-control-password {
  width: 100%;
  padding-right: 10% !important;
}
.width-control-small {
  width: 100%;
  /* margin: 0 auto; */
  /* margin-left: 30px; */
  /* height: 64px; */
}
.field-headings-userDetails:first-child {
  font-size: 12px !important;
  font-weight: bold !important;
  letter-spacing: 0.2px !important;
  color: #484848 !important;
  margin: 0 !important;
}
.field-headings-userDetails {
  font-size: 12px !important;
  font-weight: bold !important;
  letter-spacing: 0.2px !important;
  color: #484848 !important;
  margin: 0 !important;
  margin-bottom: 42px !important;
}
.card-layout-small {
  border: 1px solid #bababa;
  box-shadow: none;
  border-radius: 10px;
  width: 40%;
  margin: 0 auto;
}
.hiddenPassword {
  position: absolute;
      right: 25px !important;
    top: 30px !important;
}
.showPassword {
  position: absolute;
  top: 50%;
  left: 85% !important;
}
.green-round {
  border: 1px solid green;
  border-radius: 50%;
}
.checkUserSuccess {
  width: 20px;
  height: 20px;
  position: absolute;
      top: 30px;
    right: 25px;
}
.username-available {
  /*position: absolute;*/
  margin: 0 auto;
  font-size: 12px;
  font-weight: 500;
  font-style: normal;
  color: #28b915;
}
.credentials > .field-headings-userDetails:first-child > .alert-danger,
.alert {
  /*position: absolute !important;
  top: 79%;
  z-index: 1000;
  width: 90% !important;*/
    top: -10%;
    z-index: 1000;
    width: 100% !important;
    padding: 5px !important;
    padding: 10px 15px !important;
    font-size: 12px !important;
}
/* User details page ends */

/* Terms and conditions style */

.terms-conditions {
  margin-bottom: 50px;
  height: auto;
  margin: 0 auto;
  display: block;
  background: #edf2fa;
  width: fit-content;
  font-size: 15px;
  font-weight: 500;
  line-height: 1.23;
  letter-spacing: normal;
  color: #0071bc;
  padding: 10px;
}

.terms-link {
  cursor: pointer;
  text-decoration: underline;
  font-weight: bold;
  color:blue;
  font-size: 16px;
}

/* Terms style ends */

/* otp page design starts */
.validate-otp-heading {
  font-family: "Exo", sans-serif;
  font-size: 30px;
  font-weight: normal;
  line-height: 1.4;
  text-align: left;
  color: #002d72;
}
.hr-solid-otp-modal {
  opacity: 0.27;
  background-color: #000000;
}
.mobile-number-text-otp-modal {
  font-family: "Lato", sans-serif;
  font-size: 20px;
  font-weight: normal;
  letter-spacing: 0.3px;
  text-align: left;
  color: #0f1827;
}
.verify-btn-otp-modal {
  font-family: "Lato", sans-serif;
  font-size: 20px;
  font-weight: bold;
  font-style: normal;
  background: none;
  line-height: 1.2;
  letter-spacing: 0.8px;
  text-align: left;
  color: #0843a8;
  border: none;
  outline: 0;
  float: left;
}
.verify-btn-otp-modal:disabled {
  color: #db1414 !important;
  opacity: 0.65;
}
.btn-secondary:not(:disabled):not(.disabled):active,
.btn-secondary:not(:disabled):not(.disabled).active,
.show > .btn-secondary.dropdown-toggle {
  color: #0843a8;
  border: none;
  outline: 0;
  background: none;
}

/* otp modal design ends */

/* Success Page */
.success-mark {
  width: 143.4px;
  height: 143.4px;
  background-color: #28b915;
  border-radius: 50%;
  margin: 0 auto;
  margin-top: 3% !important;
}
.tick {
  width: 100px;
  height: 140px;
}
.reg-success-text {
  margin-top: 70px;
  font-size: 40px;
  font-weight: normal;
  line-height: 1.08;
  letter-spacing: 0.4px;
  text-align: center;
  color: #002d72;
}
.reg-subtext {
  margin-top: 19px;
  font-size: 30px;
  font-weight: normal;
  line-height: 1.47;
  letter-spacing: 0.3px;
  text-align: center;
  color: #484848;
}
.success-btn-row {
  margin-top: 50px !important;
  margin-left: 35%;
  margin-right: 35%;
}
.reset-button {
  width: 197.7px;
  height: 40px;
  border-radius: 2px;
  border: solid 1px #1579ab;
  background-color: white;
  font-family: "Source Sans Pro", sans-serif !important;
  font-size: 16px;
  font-weight: normal !important;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.25;
  letter-spacing: normal;
  text-align: center;
  color: #1579ab;
  text-transform: none;
  box-shadow: none !important;
}
/* Success page design ends */
.left-arrow {
  transform: rotate(180deg);
}
.progress-tick-orange {
  border: 1px dashed #efa500;
  float: right;
  margin: auto;
  border-radius: 50%;
  padding: 1px;
  margin-top: 8px;
  font-size: 18px;
  color: #efa500;
}
.progress-tick-green {
  border: none;
  background: #28b915;
  float: right;
  margin: auto;
  border-radius: 50%;
  padding: 1px;
  margin-top: 8px;
  font-size: 18px;
  color: white;
}
.errormsg-credential {
  margin-top: 15px;
}
.resend {
  font-family: "Titillium Web", sans-serif;
  letter-spacing: 0.96px;
  font-size: 16px;
  color: #0843a8;
  font-weight: bold;
  text-decoration: underline;
  cursor: pointer;
}
[disabled="disabled"]{opacity: 0.5;pointer-events: none;}


legend{
  font-size: 14px !important;
}

.inf{
  font-family: auto;
    font-style: italic;
    color: #156aa6;
    border: 1px soild #156aa6;
    border-width: 1px;
    border-style: solid;
    padding: 0px 7px;
    border-radius: 50px;
    font-size: 17px;
    font-weight: bold;
    cursor: pointer;margin-left: 4px;
}

</style>
